import { lazy } from 'react';

const ReportsRoutes = [
    {
        path: '/agent_us_reports',
        component: lazy(() => import('../../pages/Reports/ECBAReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/all_referrals',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/AllReferrals'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/referrals_to_member',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/ReferralsToMember'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/matters',
        component: lazy(() =>
            import('../../pages/Reports/ECBAReports/ReferralReports/Matters'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/forwarding_fee_remittance',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/ForwardigFeeRemittance'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/forwarding_fee_remittance_summary',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/ForwardingFeeRemittanceSummary'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/referral-intake-and-ffsumary',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/ReferralIntakeFFSummary'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/referrals_to_other_service',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/ReferralsToOtherServices'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/matter_update_aging',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/MatterUpdateAging'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/referrals/matter-last-update-by-member',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ReferralReports/MatterLastUpdateByMember'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/panel_count',
        component: lazy(() =>
            import('../../pages/Reports/ECBAReports/LawyerReports/PanelCount'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/insurance',
        component: lazy(() =>
            import('../../pages/Reports/ECBAReports/LawyerReports/Insurance'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/member_registrations_by_panel',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/MembersByPanel'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/membership_period',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/MembershipPeriod'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/membership_status',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/MembershipStatus'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/cleint_self_book_panels',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/ClientSelfBookPanels'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/lawyer_status',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/LawyerStatus'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/change-log',
        component: lazy(() =>
            import('../../pages/Reports/ECBAReports/LawyerReports/ChangeLog'),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/lawyers/member_registration_by_pa_city',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/LawyerReports/MemberRegistrationByPracticeAreaAndLawFirmCity'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/cleints/client_surveys',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/ClientReports/ClientSurveys'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/forwarding_fee_transactions',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/ForwardingFees'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/referral_fee',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/ReferralFees'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/referral_fee_details',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/ReferralFeeDetails'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/referral_fee_all_payments',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/ReferralFeeAllPayments'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/payouts',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/PayoutReports'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
    {
        path: '/agent_us_reports/transactions/payout-details',
        component: lazy(() =>
            import(
                '../../pages/Reports/ECBAReports/TransactionReports/PayoutDetails'
            ),
        ),
        exact: true,
        meta: {
            action: 'read',
            resource: 'ecba_reports',
        },
    },
];

export default ReportsRoutes;
